import { Timestamp } from '@angular/fire/firestore';
import { createAction, props } from '@ngrx/store';
import { AppExceptionModel } from '../../models/app-exception.model';
import { Exam } from '../../models/exam.school.model';

export const getExams = createAction(
  '[School Exam] Get Exams',
  props<{
    groupId: string;
    academicYear: number;
    createdById?: string;
    fromDate?: Timestamp;
    toDate?: Timestamp;
    lastRecord?: Timestamp;
  }>(),
);

export const addExamsToStore = createAction(
  '[School Exam] Add Exams to store',
  props<{ exams: Exam[] }>(),
);
export const addExamToStore = createAction(
  '[School Exam] Add Exam to store',
  props<{ exam: Exam }>(),
);

export const getExamsFailure = createAction(
  '[School Exam] Get Exams Failed',
  props<{ error: AppExceptionModel }>(),
);

export const getExam = createAction(
  '[School Exam] Get exam',
  props<{ groupId: string; examId: string }>(),
);

export const getExamFailure = createAction(
  '[School Exam] Get exam failure',
  props<{ error: AppExceptionModel }>(),
);

// Create Exam Actions
export const create = createAction(
  '[School Exam] Create',
  props<{ groupId: string; exam: Exam }>(),
);
export const createFailure = createAction(
  '[School Exam] Create Failure',
  props<{ error: AppExceptionModel }>(),
);
export const createSuccess = createAction(
  '[School Exam] Create Success',
  props<{ exam: Exam }>(),
);

// Update Exam Actions
export const update = createAction(
  '[School Exam] Update',
  props<{ groupId: string; examId: string; exam: Exam }>(),
);
export const updateFailure = createAction(
  '[School Exam] Update Failure',
  props<{ error: AppExceptionModel }>(),
);
export const updateSuccess = createAction(
  '[School Exam] Update Success',
  props<{ exam: Exam }>(),
);

// Delete Exam Actions
export const deleteAction = createAction(
  '[School Exam] Delete',
  props<{ groupId: string; id: string }>(),
);
export const deleteFailure = createAction(
  '[School Exam] Delete failure',
  props<{ error: AppExceptionModel }>(),
);
export const deleteSuccess = createAction(
  '[School Exam] Delete success',
  props<{ id: string }>(),
);

export const deleteFromStore = createAction(
  '[School Exam] Clear from store',
  props<{ id: string }>(),
);

export const loadExamStats = createAction(
  '[School Grade] Load Exams Stats',
  props<{ groupId: string }>(),
);

export const clear = createAction('[School Exam] Clear Exams');

export const clearFromStore = createAction(
  '[School Exam] Clear multiple from store',
  props<{ ids: string[] }>(),
);

export const clearByAcademicYear = createAction(
  '[School Exam] Clear Exams By Academic Year',
  props<{ groupId: string; academicYear: number }>(),
);
